/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM Web API
 * API endpoints for web application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AddTaskCommentCommand } from '../models';
// @ts-ignore
import { AssignTaskItemCommand } from '../models';
// @ts-ignore
import { CreateTaskItemCommand } from '../models';
// @ts-ignore
import { TaskItemDetailDto } from '../models';
// @ts-ignore
import { TaskItemDtoPaginatedList } from '../models';
// @ts-ignore
import { TaskPriority } from '../models';
// @ts-ignore
import { TaskStatus } from '../models';
// @ts-ignore
import { UpdateTaskItemCommand } from '../models';
/**
 * TaskItemsApi - axios parameter creator
 * @export
 */
export const TaskItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {TaskStatus} [status] 
         * @param {TaskPriority} [priority] 
         * @param {string} [assignedToId] 
         * @param {number} [projectId] 
         * @param {boolean} [overdueOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskItemsGet: async (pageNumber?: number, pageSize?: number, searchTerm?: string, status?: TaskStatus, priority?: TaskPriority, assignedToId?: string, projectId?: number, overdueOnly?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/TaskItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (status !== undefined) {
                localVarQueryParameter['Status'] = status;
            }

            if (priority !== undefined) {
                localVarQueryParameter['Priority'] = priority;
            }

            if (assignedToId !== undefined) {
                localVarQueryParameter['AssignedToId'] = assignedToId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['ProjectId'] = projectId;
            }

            if (overdueOnly !== undefined) {
                localVarQueryParameter['OverdueOnly'] = overdueOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {AssignTaskItemCommand} [assignTaskItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskItemsIdAssignPost: async (id: number, assignTaskItemCommand?: AssignTaskItemCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaskItemsIdAssignPost', 'id', id)
            const localVarPath = `/api/TaskItems/{id}/assign`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignTaskItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {AddTaskCommentCommand} [addTaskCommentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskItemsIdCommentsPost: async (id: number, addTaskCommentCommand?: AddTaskCommentCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaskItemsIdCommentsPost', 'id', id)
            const localVarPath = `/api/TaskItems/{id}/comments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addTaskCommentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskItemsIdCompletePost: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaskItemsIdCompletePost', 'id', id)
            const localVarPath = `/api/TaskItems/{id}/complete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskItemsIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaskItemsIdDelete', 'id', id)
            const localVarPath = `/api/TaskItems/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskItemsIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaskItemsIdGet', 'id', id)
            const localVarPath = `/api/TaskItems/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateTaskItemCommand} [updateTaskItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskItemsIdPut: async (id: number, updateTaskItemCommand?: UpdateTaskItemCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaskItemsIdPut', 'id', id)
            const localVarPath = `/api/TaskItems/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTaskItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTaskItemCommand} [createTaskItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskItemsPost: async (createTaskItemCommand?: CreateTaskItemCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/TaskItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTaskItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaskItemsApi - functional programming interface
 * @export
 */
export const TaskItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaskItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {TaskStatus} [status] 
         * @param {TaskPriority} [priority] 
         * @param {string} [assignedToId] 
         * @param {number} [projectId] 
         * @param {boolean} [overdueOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaskItemsGet(pageNumber?: number, pageSize?: number, searchTerm?: string, status?: TaskStatus, priority?: TaskPriority, assignedToId?: string, projectId?: number, overdueOnly?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskItemDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaskItemsGet(pageNumber, pageSize, searchTerm, status, priority, assignedToId, projectId, overdueOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {AssignTaskItemCommand} [assignTaskItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaskItemsIdAssignPost(id: number, assignTaskItemCommand?: AssignTaskItemCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaskItemsIdAssignPost(id, assignTaskItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {AddTaskCommentCommand} [addTaskCommentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaskItemsIdCommentsPost(id: number, addTaskCommentCommand?: AddTaskCommentCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaskItemsIdCommentsPost(id, addTaskCommentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaskItemsIdCompletePost(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaskItemsIdCompletePost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaskItemsIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaskItemsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaskItemsIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskItemDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaskItemsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateTaskItemCommand} [updateTaskItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaskItemsIdPut(id: number, updateTaskItemCommand?: UpdateTaskItemCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaskItemsIdPut(id, updateTaskItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateTaskItemCommand} [createTaskItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaskItemsPost(createTaskItemCommand?: CreateTaskItemCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaskItemsPost(createTaskItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TaskItemsApi - factory interface
 * @export
 */
export const TaskItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaskItemsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {TaskStatus} [status] 
         * @param {TaskPriority} [priority] 
         * @param {string} [assignedToId] 
         * @param {number} [projectId] 
         * @param {boolean} [overdueOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskItemsGet(pageNumber?: number, pageSize?: number, searchTerm?: string, status?: TaskStatus, priority?: TaskPriority, assignedToId?: string, projectId?: number, overdueOnly?: boolean, options?: any): AxiosPromise<TaskItemDtoPaginatedList> {
            return localVarFp.apiTaskItemsGet(pageNumber, pageSize, searchTerm, status, priority, assignedToId, projectId, overdueOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {AssignTaskItemCommand} [assignTaskItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskItemsIdAssignPost(id: number, assignTaskItemCommand?: AssignTaskItemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiTaskItemsIdAssignPost(id, assignTaskItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {AddTaskCommentCommand} [addTaskCommentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskItemsIdCommentsPost(id: number, addTaskCommentCommand?: AddTaskCommentCommand, options?: any): AxiosPromise<number> {
            return localVarFp.apiTaskItemsIdCommentsPost(id, addTaskCommentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskItemsIdCompletePost(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiTaskItemsIdCompletePost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskItemsIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiTaskItemsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskItemsIdGet(id: number, options?: any): AxiosPromise<TaskItemDetailDto> {
            return localVarFp.apiTaskItemsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateTaskItemCommand} [updateTaskItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskItemsIdPut(id: number, updateTaskItemCommand?: UpdateTaskItemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiTaskItemsIdPut(id, updateTaskItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateTaskItemCommand} [createTaskItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaskItemsPost(createTaskItemCommand?: CreateTaskItemCommand, options?: any): AxiosPromise<number> {
            return localVarFp.apiTaskItemsPost(createTaskItemCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiTaskItemsGet operation in TaskItemsApi.
 * @export
 * @interface TaskItemsApiApiTaskItemsGetRequest
 */
export interface TaskItemsApiApiTaskItemsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof TaskItemsApiApiTaskItemsGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof TaskItemsApiApiTaskItemsGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof TaskItemsApiApiTaskItemsGet
     */
    readonly searchTerm?: string

    /**
     * 
     * @type {TaskStatus}
     * @memberof TaskItemsApiApiTaskItemsGet
     */
    readonly status?: TaskStatus

    /**
     * 
     * @type {TaskPriority}
     * @memberof TaskItemsApiApiTaskItemsGet
     */
    readonly priority?: TaskPriority

    /**
     * 
     * @type {string}
     * @memberof TaskItemsApiApiTaskItemsGet
     */
    readonly assignedToId?: string

    /**
     * 
     * @type {number}
     * @memberof TaskItemsApiApiTaskItemsGet
     */
    readonly projectId?: number

    /**
     * 
     * @type {boolean}
     * @memberof TaskItemsApiApiTaskItemsGet
     */
    readonly overdueOnly?: boolean
}

/**
 * Request parameters for apiTaskItemsIdAssignPost operation in TaskItemsApi.
 * @export
 * @interface TaskItemsApiApiTaskItemsIdAssignPostRequest
 */
export interface TaskItemsApiApiTaskItemsIdAssignPostRequest {
    /**
     * 
     * @type {number}
     * @memberof TaskItemsApiApiTaskItemsIdAssignPost
     */
    readonly id: number

    /**
     * 
     * @type {AssignTaskItemCommand}
     * @memberof TaskItemsApiApiTaskItemsIdAssignPost
     */
    readonly assignTaskItemCommand?: AssignTaskItemCommand
}

/**
 * Request parameters for apiTaskItemsIdCommentsPost operation in TaskItemsApi.
 * @export
 * @interface TaskItemsApiApiTaskItemsIdCommentsPostRequest
 */
export interface TaskItemsApiApiTaskItemsIdCommentsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof TaskItemsApiApiTaskItemsIdCommentsPost
     */
    readonly id: number

    /**
     * 
     * @type {AddTaskCommentCommand}
     * @memberof TaskItemsApiApiTaskItemsIdCommentsPost
     */
    readonly addTaskCommentCommand?: AddTaskCommentCommand
}

/**
 * Request parameters for apiTaskItemsIdCompletePost operation in TaskItemsApi.
 * @export
 * @interface TaskItemsApiApiTaskItemsIdCompletePostRequest
 */
export interface TaskItemsApiApiTaskItemsIdCompletePostRequest {
    /**
     * 
     * @type {number}
     * @memberof TaskItemsApiApiTaskItemsIdCompletePost
     */
    readonly id: number
}

/**
 * Request parameters for apiTaskItemsIdDelete operation in TaskItemsApi.
 * @export
 * @interface TaskItemsApiApiTaskItemsIdDeleteRequest
 */
export interface TaskItemsApiApiTaskItemsIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof TaskItemsApiApiTaskItemsIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for apiTaskItemsIdGet operation in TaskItemsApi.
 * @export
 * @interface TaskItemsApiApiTaskItemsIdGetRequest
 */
export interface TaskItemsApiApiTaskItemsIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof TaskItemsApiApiTaskItemsIdGet
     */
    readonly id: number
}

/**
 * Request parameters for apiTaskItemsIdPut operation in TaskItemsApi.
 * @export
 * @interface TaskItemsApiApiTaskItemsIdPutRequest
 */
export interface TaskItemsApiApiTaskItemsIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof TaskItemsApiApiTaskItemsIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateTaskItemCommand}
     * @memberof TaskItemsApiApiTaskItemsIdPut
     */
    readonly updateTaskItemCommand?: UpdateTaskItemCommand
}

/**
 * Request parameters for apiTaskItemsPost operation in TaskItemsApi.
 * @export
 * @interface TaskItemsApiApiTaskItemsPostRequest
 */
export interface TaskItemsApiApiTaskItemsPostRequest {
    /**
     * 
     * @type {CreateTaskItemCommand}
     * @memberof TaskItemsApiApiTaskItemsPost
     */
    readonly createTaskItemCommand?: CreateTaskItemCommand
}

/**
 * TaskItemsApi - object-oriented interface
 * @export
 * @class TaskItemsApi
 * @extends {BaseAPI}
 */
export class TaskItemsApi extends BaseAPI {
    /**
     * 
     * @param {TaskItemsApiApiTaskItemsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskItemsApi
     */
    public apiTaskItemsGet(requestParameters: TaskItemsApiApiTaskItemsGetRequest = {}, options?: AxiosRequestConfig) {
        return TaskItemsApiFp(this.configuration).apiTaskItemsGet(requestParameters.pageNumber, requestParameters.pageSize, requestParameters.searchTerm, requestParameters.status, requestParameters.priority, requestParameters.assignedToId, requestParameters.projectId, requestParameters.overdueOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaskItemsApiApiTaskItemsIdAssignPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskItemsApi
     */
    public apiTaskItemsIdAssignPost(requestParameters: TaskItemsApiApiTaskItemsIdAssignPostRequest, options?: AxiosRequestConfig) {
        return TaskItemsApiFp(this.configuration).apiTaskItemsIdAssignPost(requestParameters.id, requestParameters.assignTaskItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaskItemsApiApiTaskItemsIdCommentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskItemsApi
     */
    public apiTaskItemsIdCommentsPost(requestParameters: TaskItemsApiApiTaskItemsIdCommentsPostRequest, options?: AxiosRequestConfig) {
        return TaskItemsApiFp(this.configuration).apiTaskItemsIdCommentsPost(requestParameters.id, requestParameters.addTaskCommentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaskItemsApiApiTaskItemsIdCompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskItemsApi
     */
    public apiTaskItemsIdCompletePost(requestParameters: TaskItemsApiApiTaskItemsIdCompletePostRequest, options?: AxiosRequestConfig) {
        return TaskItemsApiFp(this.configuration).apiTaskItemsIdCompletePost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaskItemsApiApiTaskItemsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskItemsApi
     */
    public apiTaskItemsIdDelete(requestParameters: TaskItemsApiApiTaskItemsIdDeleteRequest, options?: AxiosRequestConfig) {
        return TaskItemsApiFp(this.configuration).apiTaskItemsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaskItemsApiApiTaskItemsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskItemsApi
     */
    public apiTaskItemsIdGet(requestParameters: TaskItemsApiApiTaskItemsIdGetRequest, options?: AxiosRequestConfig) {
        return TaskItemsApiFp(this.configuration).apiTaskItemsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaskItemsApiApiTaskItemsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskItemsApi
     */
    public apiTaskItemsIdPut(requestParameters: TaskItemsApiApiTaskItemsIdPutRequest, options?: AxiosRequestConfig) {
        return TaskItemsApiFp(this.configuration).apiTaskItemsIdPut(requestParameters.id, requestParameters.updateTaskItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaskItemsApiApiTaskItemsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskItemsApi
     */
    public apiTaskItemsPost(requestParameters: TaskItemsApiApiTaskItemsPostRequest = {}, options?: AxiosRequestConfig) {
        return TaskItemsApiFp(this.configuration).apiTaskItemsPost(requestParameters.createTaskItemCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
